import React, { useState } from "react";

interface IDetailViewCancelButtonProps {
  onCancel: () => void;
  showOnPost?: boolean;
}
const DetailViewCancelButton = ({ onCancel, showOnPost }: IDetailViewCancelButtonProps) => {
  const [cancelClicked, setCancelClicked] = useState<boolean>(false);

  const handleCancelClick = async () => {
    setCancelClicked(true);
    await onCancel();
    setCancelClicked(false);
  };

  return (
    <div>
      {!showOnPost && (
        <button type={"button"} className={"btn btn-light me-2"} onClick={handleCancelClick}>
          {cancelClicked ? (
            <>
              <i className="fa-solid fa-spinner fa-spin-pulse me-2"></i>
              Canceling
            </>
          ) : (
            <>
              <i className="fa-solid fa-ban me-2"></i>
              Cancel
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default DetailViewCancelButton;
